module.exports = __webpack_public_path__ + "static/media/obrero.741dff67.png";